/* eslint-disable */

import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Badge,
} from '@chakra-ui/react';
import Card from "../../../../components/card/Card";
import { Link as RouterLink } from 'react-router-dom';
import { getBusinessSlug } from '../../../../utils/slugify';

export default function ComplexTable({ tableData = [], isLoading, orderStats = {} }) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (Array.isArray(tableData)) {
      setOrders(tableData);
    }
  }, [tableData]);

  // Stats verilerini güvenli bir şekilde al
  const stats = React.useMemo(() => ({
    active: orders.length || 0,
    delivered: orderStats?.data?.deliveredOrders || 0,
    cancelled: orderStats?.data?.cancelledOrders || 0
  }), [orders, orderStats]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Beklemede': return 'gray';
      case 'Hazırlanıyor': return 'yellow';
      case 'Hazır': return 'blue';
      case 'Teslim Edildi': return 'green';
      case 'İptal Edildi': return 'red';
      default: return 'gray';
    }
  };

  if (isLoading) {
    return (
      <Card>
        <Flex justify="center" align="center" p={4}>
          <Text>Yükleniyor...</Text>
        </Flex>
      </Card>
    );
  }

  return (
    <Card flexDirection="column" w="100%" px="25px">
      <Flex mb="20px" justifyContent="space-between" align="center">
        <Text color={textColor} fontSize="22px" fontWeight="700" lineHeight="100%">
          Günlük Sipariş Durumu
        </Text>
      </Flex>

      {/* Aktif Siparişler - Tek Kolon */}
      <Box mb={4}>
        <Stat
          px={{ base: 2, md: 4 }}
          py="5"
          bg="blue.50"
          rounded="lg"
          textAlign="center"
        >
          <StatLabel fontWeight="medium" isTruncated color="blue.600">
            Aktif Siparişler
          </StatLabel>
          <StatNumber fontSize="3xl" fontWeight="medium" color="blue.800">
            {stats.active}
          </StatNumber>
        </Stat>
      </Box>

      {/* Teslim Edilen ve İptal Edilen - İki Kolon */}
      <SimpleGrid columns={2} spacing={4}>
        <Stat
          px={{ base: 2, md: 4 }}
          py="5"
          bg="green.50"
          rounded="lg"
          textAlign="center"
        >
          <StatLabel fontWeight="medium" isTruncated color="green.600">
            Teslim Edilen
          </StatLabel>
          <StatNumber fontSize="3xl" fontWeight="medium" color="green.800">
            {stats.delivered}
          </StatNumber>
        </Stat>

        <Stat
          px={{ base: 2, md: 4 }}
          py="5"
          bg="red.50"
          rounded="lg"
          textAlign="center"
        >
          <StatLabel fontWeight="medium" isTruncated color="red.600">
            İptal Edilen
          </StatLabel>
          <StatNumber fontSize="3xl" fontWeight="medium" color="red.800">
            {stats.cancelled}
          </StatNumber>
        </Stat>
      </SimpleGrid>

      {/* Son Aktif Siparişler */}
      {orders && orders.length > 0 && (
        <Box mt={6}>
          <Text color={textColor} fontSize="lg" fontWeight="600" mb={3}>
            Son Aktif Siparişler
          </Text>
          <SimpleGrid columns={1} spacing={3}>
            {orders.slice(0, 2).map((order) => (
              <Box
                key={order.id}
                p={3}
                bg="gray.50"
                rounded="lg"
                border="1px"
                borderColor="gray.200"
              >
                <Flex justify="space-between" align="center">
                  <Flex gap={4} align="center">
                    <Text fontWeight="600">
                      {order.tableName || order.masa_id}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      {new Date(order.createdAt).toLocaleTimeString('tr-TR')}
                    </Text>
                  </Flex>
                  <Badge colorScheme={getStatusColor(order.status)}>
                    {order.status}
                  </Badge>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>

          <Flex justify="center" mt={4}>
            <RouterLink to={`/admin/${getBusinessSlug() || 'panel'}/siparisler`}>
              <Text
                color="blue.500"
                fontSize="sm"
                fontWeight="500"
                _hover={{
                  color: 'blue.600',
                  textDecoration: 'underline'
                }}
                cursor="pointer"
              >
                Tüm siparişleri görüntülemek için tıklayın →
              </Text>
            </RouterLink>
          </Flex>
        </Box>
      )}
    </Card>
  );
}